import { Button, Collapse, List, ListItem, ListItemText, Menu, MenuItem } from '@material-ui/core'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import React from 'react'
import HomeIcon from '@material-ui/icons/Home';
import MenuIcon from '@material-ui/icons/Menu';
import { styles } from '../index.styles';
import bulbIcon from '../../bulb.png';
import { navbarMobileSubMenuLinks } from '../../../constants';



const MobileNav = ({ menuState, setMenuState }) => {

  const menuItems = [
    { title: 'Home', url: 'https://optionsgeek.com/welcome-home-page/' },
    { title: 'Pricing', url: 'https://optionsgeek.com/pricing/' }
  ];

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={styles.hamburger}>
        <Button
          aria-owns={menuState.anchorEl ? 'simple-menu' : null}
          aria-haspopup='true'
          color='secondary'
          onClick={(event) => setMenuState({ ...menuState, anchorEl: event.currentTarget })}
          mini="true"
          size='small'
          style={styles.hamburgerButton}
        >
          <MenuIcon />
        </Button>
        <Menu
          id='simple-menu'
          anchorEl={menuState.anchorEl}
          open={Boolean(menuState.anchorEl)}
          onClose={() => setMenuState({ ...menuState, anchorEl: null })}
          style={{ zIndex: 10000 }}
        >
          <Collapse
            in={menuState.openSub1}
            timeout='auto'
            unmountOnExit
          >
            <List component='div' disablePadding></List>
          </Collapse>
          {menuItems.map((item) => (
            <MenuItem style={{ textTransform: 'none' }}>
              <a style={styles.submenu} href={item.url}>{item.title}</a>
            </MenuItem>
          ))}
          <MenuItem button onClick={() => setMenuState({ ...menuState, openSub2: !menuState.openSub2 })}>
            <ListItemText primary='Products' />
            {menuState.openSub2 ? (
              <ExpandLess />
            ) : (
              <ExpandMore />
            )}
          </MenuItem>
          <Collapse
            in={menuState.openSub2}
            timeout='auto'
            unmountOnExit
          >

            <List component='div' disablePadding>

              {navbarMobileSubMenuLinks.map((item) => (
                <ListItem button style={{ paddingLeft: "2em" }} key={item.url}>
                  <a style={styles.submenu} href={item.url}>
                    {item.title}
                  </a>
                </ListItem>
              ))}
            </List>
          </Collapse>
        </Menu>
      </div>
      <div style={{ width: '19px' }}>
        <a
          href='https://optionsgeek.com/forum/?p=categories'
          style={{
            backgroundColor: 'rgb(1, 153, 52)',
            padding: '14px 11.5px 2px 11.5px',
            color: 'white',
            textDecoration: 'none',
            fontSize: '14px',
            fontWeight: 'bold',
          }}
        >
          <img
            height='24px'
            width='20px'
            src={bulbIcon}
            alt=""
          />
        </a>
      </div>

      <div style={{ marginLeft: '35px' }}>
        <a
          href='https://optionsgeek.com/welcome-home-page/'
          style={{
            backgroundColor: 'rgb(0,111,176)',
            padding: '14px 10px 2px 9px',
            color: 'white',
            textDecoration: 'none',
            fontSize: '14px',
            fontWeight: 'bold',
          }}
        >
          <HomeIcon />
        </a>
      </div>
    </div>
  )
}

export default MobileNav


// WEBPACK FOOTER //
// ./src/components/Header/Navbar/MobileNav.jsx